const INVALID_OLIVE_OFFER_IDS = new Set([
  'bottom featured',
  'top featured',
  'featured',
  'n/a',
  'na',
  'none',
  'tbd',
  '-',
]);

export function isPlausibleOliveOfferId(offerId) {
  if (offerId == null) return false;
  const value = String(offerId).trim();
  if (!value || /\s/.test(value)) return false;
  return !INVALID_OLIVE_OFFER_IDS.has(value.toLowerCase());
}

export function isClickOffer(offer) {
  const type = String(offer?.offerType || offer?.offer_type || '').toLowerCase();
  return type === 'click' || type === 'click_sso' || type === 'online';
}

export function isWildfireOffer(offer) {
  if (!offer) return false;
  if (isClickOffer(offer)) return true;
  const source = String(offer.offerSource || offer.offer_source || '').toLowerCase();
  if (source === 'wildfire') return true;
  return !!(offer.wildfireMerchantId || offer.wildfire_merchant_id);
}

export function wildfireStoreOffer(item) {
  const merchantId = item.wildfireMerchantId || item.wildfire_merchant_id || item.merchantId || item.id;
  const logo = item.small_logo_url || item.large_logo_url || item.logoUrl || item.logo || '';
  return {
    ...item,
    name: item.name || item.merchantName || '',
    small_logo_url: logo,
    large_logo_url: item.large_logo_url || logo,
    offer_type: 'click',
    offerType: 'click',
    offerSource: 'wildfire',
    offer_source: 'wildfire',
    wildfireMerchantId: merchantId,
    wildfire_merchant_id: merchantId,
  };
}

export function featuredPartnerOffer(raw) {
  const offerId = raw.offer_id || raw.offerId || raw.id;
  const online = String(raw.channel || '').toLowerCase() === 'online' || isClickOffer(raw);
  const plausible = isPlausibleOliveOfferId(raw.offer_id);
  const logoUrl = raw.large_logo_url || raw.small_logo_url || raw.logoUrl;
  if (online) {
    return {
      ...raw,
      offerType: 'click',
      offerId: plausible ? String(raw.offer_id).trim() : raw.id,
      logoUrl,
    };
  }
  return {
    ...raw,
    offer_id: raw.offer_id || offerId,
    logoUrl,
    offerType: 'cardlinked',
    offerId: plausible ? String(raw.offer_id).trim() : undefined,
  };
}

export function offerPath(offer) {
  const wildfire = isWildfireOffer(offer);
  const id = wildfire
    ? offer.wildfireMerchantId || offer.wildfire_merchant_id || offer.offerId || offer.id
    : offer.offerId || offer.offer_id || offer.id;
  return `/shop/offer/${encodeURIComponent(String(id || 'unknown'))}?source=${wildfire ? 'wildfire' : 'olive'}`;
}
